import React, { useState } from 'react'
import { Modal } from "antd";
import Close from "../../../../resources/imgs/modal/close.svg";
import { FaChevronRight } from "react-icons/fa";
import Progress from "../../progress";
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg"
import { useRecoilValue } from 'recoil';
import { loveInterestAtom, randomGuestAtom } from '../../../../state/assessment';

export default function Index(props) {
  const loveInterestObj = useRecoilValue(loveInterestAtom);
  const loveInterest = typeof loveInterestObj === 'object' ? loveInterestObj.loveInterest : loveInterestObj;
  const [open, setOpen] = useState(false);

  // Final Orders guest list - guests that appear in both Module 3 and are available in cardData
  const FINAL_ORDER_GUESTS = [
    { name: "Manuel" },
    { name: "Karl" },
    { name: "Trish" },
    { name: "Joey" }
  ];

  // Use the same selection logic as Module 8-4 to ensure same guest
  const randomGuest = React.useMemo(() => {
    if (!props.cardData) return null;
    
    // Filter out love interest (same logic as Module 8-4)
    const loveInterestName = typeof loveInterest === 'object' ? loveInterest.loveInterest : loveInterest;
    const availableGuestNames = FINAL_ORDER_GUESTS.filter(guest => guest.name !== loveInterestName).map(g => g.name);
    const availableGuestData = props.cardData?.filter(guest => availableGuestNames.includes(guest.name)) || [];
    
    // Use deterministic selection - always pick the first available guest for consistency
    return availableGuestData[0];
  }, [props.cardData, loveInterest]);

  // Calculate correct answer - the two guests sitting next to the selected guest
  const correctNeighbors = React.useMemo(() => {
    if (!randomGuest || !props.cardData) return [];
    
    const selectedIndex = props.cardData.findIndex(guest => guest.name === randomGuest.name);
    if (selectedIndex === -1) return [];
    
    const totalGuests = props.cardData.length;
    const leftNeighbor = props.cardData[(selectedIndex - 1 + totalGuests) % totalGuests];
    const rightNeighbor = props.cardData[(selectedIndex + 1) % totalGuests];
    
    console.log(`🔍 Seating: ${randomGuest.name} (pos ${selectedIndex}) sits between ${leftNeighbor.name} and ${rightNeighbor.name}`);
    
    return [leftNeighbor.name, rightNeighbor.name].sort(); // Sort for consistent comparison
  }, [randomGuest, props.cardData]);

  console.log('🔍 Module 8-6 randomGuest:', randomGuest);
  console.log('🔍 Module 8-6 correct neighbors:', correctNeighbors);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="08." percent={1} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 8</div>
          <div className="module1-body">
            <div className="module1-title">Wait a second!</div>
            <div className="module1-content1">
              <strong>Guest:</strong> Maybe {randomGuest?.name || 'someone'} stole a bite from someone they were sitting next to. Do you remember who was sitting next to {randomGuest?.name || 'them'}?
            </div>

            <div className="module1-content2">
              <strong>You:</strong> Let me think... I think it was _ _ _ _ _ _ _ and _ _ _ _ _ _ _.
            </div>
          </div>
        </div>
      </div>

      <div
        className="assessment-reset-btn card-rest-btn"
        onClick={() => { props.resetCard() }}
      >
        Reset
      </div>

      <div className="module1-card">
        {props.cardData
          .filter(item => {
            // Show all available guests except the selected guest
            return item.name !== randomGuest?.name;
          })
          .map((item, idx) => {
            // Find the original index for the selectGroupNumber function
            const originalIndex = props.cardData.findIndex(card => card.name === item.name);
            return (
              <div
                key={item.name}
                onClick={() => props.selectGroupNumber(originalIndex)}
                className="module11-card-container"
                style={{
                  borderColor: props.groupNumber.indexOf(originalIndex) + 1 ? "#F277C7" : "",
                }}
              >
                <div className="mancard-contaienr" style={{textAlign: 'center'}}>
                  <img 
                    className="man-img" 
                    src={item.img}
                    style={{
                      width: '120px',
                      height: '120px',
                      objectFit: 'cover',
                      borderRadius: '8px'
                    }}
                    alt={item.name}
                  />
                  <div className="mancard-name" style={{marginTop: '10px', fontWeight: 'bold'}}>
                    {item.name}
                  </div>
                </div>
                <div
                  className="module11-card-number"
                  style={{
                    visibility:
                      props.groupNumber.indexOf(originalIndex) + 1 ? "visible" : "hidden",
                  }}
                >
                  {props.groupNumber.indexOf(originalIndex) + 1}
                </div>
              </div>
            );
          })
        }
      </div>


      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>
        {props.groupNumber.length === 2 && (
          <div
            className="assessment-next-btn"
            onClick={() => { 
              // Check if user selected the correct two neighbors
              const selectedGuestNames = props.groupNumber
                .map(index => props.cardData[index]?.name)
                .filter(Boolean)
                .sort(); // Sort for consistent comparison
              
              const isCorrect = selectedGuestNames.length === 2 && 
                selectedGuestNames[0] === correctNeighbors[0] && 
                selectedGuestNames[1] === correctNeighbors[1];
              
              console.log('🎯 Module 8-6 Answer Check:', {
                selectedGuests: selectedGuestNames,
                correctNeighbors: correctNeighbors,
                isCorrect: isCorrect
              });
              
              // Record score if available (though Module 8-6 might not use scoring)
              if (props.recordScore) {
                props.recordScore(isCorrect, {
                  selectedGuest: randomGuest?.name,
                  userAnswer: selectedGuestNames,
                  correctAnswer: correctNeighbors
                });
              }
              
              props.nextPage();
            }}
          >
            Next{" "}
            <div
              style={{
                paddingTop: "5px",
                display: "inline-block",
              }}
            >
              <FaChevronRight color="white" size={16} />
            </div>
          </div>
        )}
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className='direction-modal-content'>
            Dessert is done. The guests are getting ready to leave and begin to get up to leave.  {loveInterest} gets up first and glances at you.  You take your chance and ask for {loveInterest}'s number and {loveInterest} whispers it to you so the other guests don't notice. Your job in this
            module is to correctly input {loveInterest}'s number after seeing it for 5 seconds. Make sure you're ready before clicking next. The timer starts right away!
          </div>
        </div>
      </Modal>
    </div>
  )
}
